<div *ngIf="isLoaded">
    <!-- Main Confirmation Modal -->
    <dialog *ngIf="message" class="modal" tabindex="-1">
      <div class="modal-dialog dialog-width">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="page-title">{{ message.title }}</h4>
          </div>
  
          <div *ngIf="message?.type == 'confirm'" class="modal-body">
            <div class="commentbox">
              <p [innerHTML]="message.text"></p>
  
              <!-- Confirmation Input Section -->
              <div *ngIf="message?.confirmationTextRequired">
                <p>Please type 
                  <strong class="confirm-message-text">
                    {{ message.requiredText || 'Type message.requiredText here' }}
                  </strong> to confirm:</p>
                <input
                  type="text"
                  class="form-control"
                  [(ngModel)]="confirmationInput"
                  [placeholder]="'Type ' + (message?.requiredText || 'confirmation text') + ' here'"
                />
              </div>
            </div>
          </div>
  
          <div class="modal-footer">
            <app-button
              size="medium"
              class ="yesbtn"
              buttonType="primary"
              (click)="onYesClick()"
              (keydown)="onYesClick()"
              [disabled]="message?.confirmationTextRequired && confirmationInput !== (message.requiredText || 'DELETE')"
            >
              Yes
            </app-button>
            <app-button
              size="medium"
              class="nobtn"
              (click)="onNoClick()"
              (keydown)="onNoClick()"
              buttonType="secondary"
            >
              No
            </app-button>
          </div>
        </div>
      </div>
    </dialog>
  
    <!-- Confirmation Modal with Close -->
    <dialog *ngIf="message_withclose" class="modal" tabindex="-1">
      <div class="modal-dialog dialog-width">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="page-title">{{ message_withclose.title }}</h4>
          </div>
  
          <div *ngIf="message_withclose?.type == 'confirm'" class="modal-body">
            <div class="commentbox">
              <p [innerHTML]="message_withclose.text"></p>
  
              <!-- Confirmation Input Section -->
              <div *ngIf="message_withclose?.confirmationTextRequired">
                <p>Please type <strong class="confirm-message-text">
                  {{ message_withclose.requiredText || 'DELETE' }}
                </strong> to confirm:</p>
                <input
                  type="text"
                  class="form-control"
                  [(ngModel)]="confirmationInput"
                  [placeholder]="'Type ' + (message?.requiredText || 'confirmation text') + ' here'"
                />
              </div>
            </div>
          </div>
  
          <div class="modal-footer">
            <app-button
              size="medium"
              class ="yesbtn"
              buttonType="primary"
              (click)="onYesClick()"
              (keydown)="onYesClick()"
              [disabled]="message_withclose?.confirmationTextRequired 
              && confirmationInput !== 
              (message_withclose.requiredText || 'DELETE')"
            >
              Yes
            </app-button>
            <app-button
              size="medium"
              class="nobtn"
              (click)="onNoClick()"
              (keydown)="onNoClick()"
              buttonType="secondary"
            >
              No
            </app-button>
          </div>
        </div>
      </div>
    </dialog>
  </div>
  